'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (duration) {
    return !!duration && duration.slice(-1) === 't';
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/duration/isDurationTick.js
// module id = 24
// module chunks = 0